import type { LocalizedText } from '@360face/domain';

/**
 * Kiosk v3 (owner 23.10.2026): 3D "soft clay" pictures in the brand style for treatments, extras
 * and the home doors. Matched by the treatment's name (English or Portuguese), so the same
 * pictures work in mock and Altegio mode. No match → no picture (the card still works).
 */
const BASE = '/v3/';

const SERVICE_ART: Array<[RegExp, string]> = [
  [/duo/i, 's-duo.jpg'],
  [/korugi/i, 's-korugi.jpg'],
  [/kobido/i, 's-kobido.jpg'],
  [/buccal|bucal/i, 's-buccal.jpg'],
  [/private/i, 's-private.jpg'],
  [/upper body|costas|back/i, 's-faceupper.jpg'],
  [/pre-?natal|gr[aá]vida|pregnan/i, 's-prenatal.jpg'],
  [/lymph|linf/i, 's-lymph.jpg'],
  [/cellul|celul|slim/i, 's-cellulite.jpg'],
  [/reflex|feet|foot|p[eé]s\b/i, 's-feet.jpg'],
  [/head|cabe[cç]a|shoulder|ombro/i, 's-headsh.jpg'],
  [/anti-?age|rugas|wrinkle/i, 's-antiage.jpg'],
  [/recharge/i, 's-recharge.jpg'],
  [/dermapen|microneedl|microagulh/i, 's-dermapen.jpg'],
  [/bright|ilumin/i, 's-bright.jpg'],
  [/aqua|hydra|hidrat/i, 's-aqua.jpg'],
  [/d-?tox/i, 's-dtox.jpg'],
  [/sebo|peel/i, 's-sebo.jpg'],
  [/carbox/i, 's-carboxy.jpg'],
  [/atraum[aá]t/i, 's-cleansing.jpg'],
  [/pore|poro|deep skin|clean|limpeza/i, 's-pore.jpg'],
  [/eye|olho/i, 'x-eyes.jpg'],
  [/body|corpo/i, 's-body.jpg'],
  [/face|facial|lift|rosto|express|optimal|maximum|workout|training/i, 's-lifting.jpg'],
];

const EXTRA_ART: Array<[RegExp, string]> = [
  [/led/i, 'x-led.jpg'],
  [/micro|ems|current|corrente/i, 'x-ems.jpg'],
  [/alginat/i, 'x-alginate.jpg'],
  [/mask|m[aá]scara/i, 'x-mask.jpg'],
  [/hand|m[aã]o/i, 'x-hand.jpg'],
  [/eye|olho|patch/i, 'x-eyes.jpg'],
  [/foot|feet|p[eé]s?\b|sock/i, 'x-feet.jpg'],
  [/head|cabe[cç]a|scalp|couro/i, 'x-head.jpg'],
  [/peel|esfolia/i, 's-sebo.jpg'],
];

function names(title: LocalizedText): string {
  return [title.en, title.pt].filter(Boolean).join(' ');
}

function pick(table: Array<[RegExp, string]>, title: LocalizedText): string | undefined {
  const text = names(title);
  const hit = table.find(([re]) => re.test(text));
  return hit ? BASE + hit[1] : undefined;
}

export const serviceArt = (title: LocalizedText) => pick(SERVICE_ART, title);
export const extraArt = (title: LocalizedText) => pick(EXTRA_ART, title) ?? pick(SERVICE_ART, title);

/** Owner 24.10.2026: 3D pictures for the payment methods (same clay style). */
export const PAY_ART: Record<string, string> = {
  card_terminal: BASE + 'pay-card.png',
  mbway: BASE + 'pay-mbway.png',
  qr_transfer: BASE + 'pay-qr.png',
  cash: BASE + 'pay-cash.png',
  bank_transfer: BASE + 'pay-bank.png',
  gift_card: BASE + 'pay-giftcard.png',
};

export const V3_ART = {
  checkin: BASE + 't-visits.png',
  book: BASE + 't-book.png',
  gift: BASE + 'gift.png',
  phone: BASE + 'phone.png',
  card: BASE + 'card.png',
};
